import { isString } from 'lodash';
export const isCurrencyAmountDto = value => !!value && !isString(value);